import { LeaveCondition } from '@Managers/StateMachine/LeaveCondition';
import { EGameStates } from './GameStates';

export type TStateConditionsNames =
    | 'gameStartCondition'
    | 'idleCondition'
    | 'reelsSpinningCondition'
    | 'winCondition'
    | 'postWinCondition'
    | 'preGambleCondition'
    | 'gambleResultCondition'
    | 'gambleCondition'
    | 'postGambleCondition';

export const StateConditions: { [K in TStateConditionsNames]: LeaveCondition<EGameStates> } = {
    gameStartCondition: new LeaveCondition('waitForStartingAnimations', EGameStates.GAME_START),
    idleCondition: new LeaveCondition('waitForUserAction', EGameStates.IDLE_STATE),
    reelsSpinningCondition: new LeaveCondition('waitUntilReelsAreFinished', EGameStates.SPIN_STATE),
    winCondition: new LeaveCondition('waitUntilWinIsFinished', EGameStates.WIN_STATE),
    postWinCondition: new LeaveCondition('waitForSpinOrTake', EGameStates.POST_WIN_STATE),
    preGambleCondition: new LeaveCondition('waitUntilGambleStartIsFinished', EGameStates.PRE_GAMBLE_STATE),
    gambleCondition: new LeaveCondition('waitUntilGambleIsFinished', EGameStates.GAMBLE_STATE),
    gambleResultCondition: new LeaveCondition('waitUntilGambleResultIsFinished', EGameStates.GAMBLE_RESULT_STATE),
    postGambleCondition: new LeaveCondition('waitUntilGambleEndIsFinished', EGameStates.POST_GAMBLE_STATE)
};
